<div class="channel-sync-indicator" [class.compact]="compact()" (click)="onIndicatorClick()">
  <div class="channel-icons-container">
    @for (channel of visibleChannels(); track channel.id; let i = $index) {
      <div class="channel-icon-wrapper" [style.z-index]="visibleChannels().length - i">
        <img
          [src]="channel.guest_reservation_source_type.logo_url"
          [alt]="channel.guest_reservation_source_type.name"
          class="channel-icon" />
      </div>
    }
    @if (remainingCount() > 0) {
      <div class="channel-icon-wrapper remaining-count" [style.z-index]="0">
        <span>+{{ remainingCount() }}</span>
      </div>
    }
  </div>
  @if (!compact()) {
    <tidy-text [body]="channels().length > 0 ? 'iCal & Channels' : 'iCal Export'" class="sync-label" />
  }
</div>
